const PrivateLock = (props) => (
  <svg fill='none' height={25} width={24} xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M18.75 8.92v2.1c-.44-.06-.94-.09-1.5-.1v-2c0-3.15-.89-5.25-5.25-5.25s-5.25 2.1-5.25 5.25v2c-.56.01-1.06.04-1.5.1v-2.1c0-2.9.7-6.75 6.75-6.75s6.75 3.85 6.75 6.75Z'
      fill='currentColor'
    />
    <path
      d='M22 15.92v2c0 4-1 5-5 5H7c-4 0-5-1-5-5v-2c0-3.34.7-4.59 3.25-4.9.44-.06.94-.09 1.5-.1h10.5c.56.01 1.06.04 1.5.1 2.55.31 3.25 1.56 3.25 4.9Z'
      fill='currentColor'
      opacity={0.4}
    />
    <path
      d='M8 17.92c-.13 0-.26-.03-.38-.08-.13-.05-.23-.12-.33-.21-.18-.19-.29-.45-.29-.71 0-.13.03-.26.08-.38s.12-.23.21-.33c.1-.09.2-.16.33-.21.37-.16.81-.07 1.09.21.09.1.16.21.21.33.05.12.08.25.08.38 0 .26-.11.52-.29.71-.19.18-.45.29-.71.29ZM12 17.92c-.27 0-.52-.11-.71-.29-.09-.1-.16-.21-.21-.33a.996.996 0 0 1-.08-.38c0-.27.11-.52.29-.71.37-.37 1.04-.37 1.42 0 .18.19.29.44.29.71 0 .13-.03.26-.08.38s-.12.23-.21.33c-.19.18-.45.29-.71.29ZM16 17.92c-.26 0-.52-.11-.71-.29-.18-.19-.29-.44-.29-.71 0-.27.11-.52.29-.71.38-.37 1.05-.37 1.42 0 .04.05.08.1.12.16.04.05.07.11.09.17.03.06.05.12.06.18.01.07.02.14.02.2 0 .26-.11.52-.29.71-.19.18-.45.29-.71.29Z'
      fill='currentColor'
    />
  </svg>
);
export default PrivateLock;
